import { handleBasicAlert } from "../alerts";
import { FETCH_AUTH_PRIVILEGE, SET_USER_PROFILE } from "../Dispatchers";
import { authorizeUser, fetchPrivileges, logout as logoutApi } from "../service/AuthService";

export const fetchPrivilegesAction = () => {
    return (dispatch) => {
        fetchPrivileges().then((response) => {
            dispatch({ type: FETCH_AUTH_PRIVILEGE, payload: response.data })
        }).catch((error) => {
            console.log(error)
        })
    }
}

export const authorizeUserAction = (mobileNumber, otp, navigate) => {
    return (dispatch) => {
        authorizeUser(mobileNumber, otp).then((response) => {
            saveProfile(response, dispatch);
            navigate(response?.data?.landingPage || '/index')
        }).catch((error) => {
            console.log(error)
            handleBasicAlert(error?.response?.data?.message || 'Login failed', "OK", "error");
        })
    }
}

export function saveProfile(response, dispatch) {
    const profile = {
        role: response.data.role,
        landingPage: response.data.landingPage,
        orgCode: response.data.orgCode,
        roleScope: response.data.roleScope,
        programCodes: response.data.programCodes,
        subscriptionStatus: response.data.subscriptionStatus,
        expiresIn: response.data.expiresIn,
    };
    sessionStorage.setItem('userProfile', JSON.stringify(profile));
    dispatch({ type: SET_USER_PROFILE, payload: profile });
}

export function Logout(navigate) {
    return () => {
        logoutApi()
            .catch(() => { /* server may already have cleared session */ })
            .finally(() => {
                sessionStorage.removeItem('userProfile');
                sessionStorage.removeItem('userDetails');
                sessionStorage.removeItem('$3ingT0k3n');
                navigate("/login");
            });
    };
}
